export const CONSUMER_REPORT_ID = '81fda41b-b1eb-4e97-bad9-e60719b0c085';
export const PRODUCER_REPORT_ID = '67d63af7-0434-408f-9cca-99680089b14c';
